import React from "react";
import { useTranslation } from "react-i18next";
import { HiOutlineDesktopComputer } from "react-icons/hi";
import { RiContactsLine } from "react-icons/ri";
import { FaLaptopCode } from "react-icons/fa";
import { SiHomeassistant } from "react-icons/si";
import { Lang } from "../../translations/component/Lang";

export const ItemsNavbar = () => {
  const [t] = useTranslation("global");

  return (
    <>
      <div className="flex justify-between ">
        <div className="hidden md:flex">
          <div
            onClick={() => window.scrollTo(0, 0)}
            className="cursor-pointer  rounded-md  shadow-md bg-white flex items-center font-md m-3"
          >
            <SiHomeassistant className="text-gray-800 mx-2 " />
            <p className=" px-2 py-2 text-gray-800 font-Poppins font-bold text-1s">
              {t("home")}
            </p>

            {/* <img loading='lazy'
              className={`"w<-9 my-1 mx-4" `}
              src="https://firebasestorage.googleapis.com/v0/b/social-academy-1c439.appspot.com/o/FOROS.svg?alt=media&token=f616856e-d5e7-4171-8207-3393de584ccf"
              alt="icon-user"
            /> */}
          </div>
        </div>
        <div className="hidden md:flex">
          <a
            href="#exp"
            className="cursor-pointer  rounded-md  shadow-md bg-white flex items-center font-md m-3"
          >
            <HiOutlineDesktopComputer className="text-gray-800 mx-2 " />
            <p className=" px-2 py-2 text-gray-800 font-Poppins font-bold text-1s">
              {t("experience")}
            </p>

            {/* <img loading='lazy'
              className={`"w-9 my-1 mx-4" `}
              src="https://firebasestorage.googleapis.com/v0/b/social-academy-1c439.appspot.com/o/FOROS.svg?alt=media&token=f616856e-d5e7-4171-8207-3393de584ccf"
              alt="icon-user"
            /> */}
          </a>
        </div>
        <div className="hidden md:flex">
          <a
            href="#skill"
            className="cursor-pointer  rounded-md  shadow-md bg-white flex items-center font-md m-3"
          >
            <FaLaptopCode className="text-gray-800 mx-2 " />
            <p className=" px-2 py-2 text-gray-800 font-Poppins font-bold text-1s">
              {t("skills")}
            </p>

            {/* <img loading='lazy'
              className={`"w-9 my-1 mx-4" `}
              src="https://firebasestorage.googleapis.com/v0/b/social-academy-1c439.appspot.com/o/FOROS.svg?alt=media&token=f616856e-d5e7-4171-8207-3393de584ccf"
              alt="icon-user"
            /> */}
          </a>
        </div>

        <div className="hidden md:flex hover:text-yellow-300">
          <a
            href="#contact"
            className="cursor-pointer  rounded-md  shadow-md bg-white flex items-center font-md m-3 hover:text-yellow-300"
          >
            <RiContactsLine className="text-gray-800 mx-2 " />
            <p className=" px-2 py-2 text-gray-800 font-Poppins font-bold text-1s ">
              {t("contact-me")}
            </p>

            {/* <img loading='lazy'
              className={`"w-9 my-1 mx-4" `}
              src="https://firebasestorage.googleapis.com/v0/b/social-academy-1c439.appspot.com/o/FOROS.svg?alt=media&token=f616856e-d5e7-4171-8207-3393de584ccf"
              alt="icon-user"
            /> */}
          </a>
        </div>

        <Lang />
      </div>
    </>
  );
};
